// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".app__OrgInfoTable__no-bottom-spacing{margin-bottom:0!important;padding-bottom:0}", "",{"version":3,"sources":["webpack://./../common/capabilities-react/twia-capability-agencyadmin-react/components/OrgInfoTable/OrgInfoTable.module.scss"],"names":[],"mappings":"AAAA,sCAEI,yBAAA,CADA,gBACA","sourcesContent":[".no-bottom-spacing {\n    padding-bottom: 0px;\n    margin-bottom: 0 !important\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"no-bottom-spacing": "app__OrgInfoTable__no-bottom-spacing"
};
export default ___CSS_LOADER_EXPORT___;
